// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__EwtN5","title":"Header_title__3GuWk","links":"Header_links__1Foxp","logo":"Header_logo__2YeBw","menu":"Header_menu__2swGb"};